document.querySelector('.pdp__main__atc__phone').addEventListener('click', function () {
  const stickyHideElement = document.querySelector('.pdp__sticky__hide');
  if (stickyHideElement) {
    stickyHideElement.style.display = 'block';
    stickyHideElement.style.opacity = '0';
    stickyHideElement.style.transition = 'opacity 0.3s ease, transform 0.3s ease';
    stickyHideElement.style.transform = 'translateY(20px)';

    setTimeout(() => {
      stickyHideElement.style.opacity = '1';
      stickyHideElement.style.transform = 'translateY(0)';
    }, 10);
  }
});
document.querySelector('.pdp__sticky__hide__close').addEventListener('click', function () {
  const stickyHideElement = document.querySelector('.pdp__sticky__hide');
  if (stickyHideElement) {
    stickyHideElement.style.opacity = '0';
    stickyHideElement.style.transform = 'translateY(20px)';
    setTimeout(() => {
      stickyHideElement.style.display = 'none';
    }, 300);
  }
});
document.querySelector('.pdp__main__atc__phone').addEventListener('click', function () {
  const stickyHideElement = document.querySelector('.pdp__sticky__hide');
  if (stickyHideElement) {
    stickyHideElement.style.display = 'block';
    stickyHideElement.style.opacity = '0';
    stickyHideElement.style.transition = 'opacity 0.3s ease, transform 0.3s ease';
    stickyHideElement.style.transform = 'translateY(20px)';

    setTimeout(() => {
      stickyHideElement.style.opacity = '1';
      stickyHideElement.style.transform = 'translateY(0)';
    }, 10);
  }
});
